import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Image from 'next/image';
import { useMobile } from 'src/hooks/useMobile';

export type BracketColumnsStackProps = {
  children: React.ReactNode[];
  connectorSx: { width: number; height: number; size: number };
};
export const BracketColumnsStack = (props: BracketColumnsStackProps) => {
  const { children, connectorSx } = props;
  const isMobile = useMobile();
  return (
    <Box position="relative">
      <Stack
        direction="row"
        alignItems="stretch"
        justifyContent="center"
        spacing={8}
      >
        {children}
      </Stack>
      {connectorSx && (
        <Stack
          position="absolute"
          zIndex={-1}
          height="100%"
          width={isMobile ? 'auto' : '100%'}
          bottom={0}
          left={isMobile ? '180px' : 0}
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Image
            width={`${connectorSx.width}px`}
            height={`${connectorSx.height}px`}
            src={`/assets/images/bracket-connectors/bracket${
              isMobile ? '-mobile' : ''
            }-${connectorSx.size}.svg`}
            alt="bracket connectors"
          />
        </Stack>
      )}
    </Box>
  );
};
